import { LoadingButton } from '@mui/lab';
import { Card, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField, Typography, useTheme, Button } from '@mui/material';
import { enqueueSnackbar } from 'notistack';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Iconify from 'src/components/iconify';
import { useBoolean } from 'src/hooks/use-boolean';
import { useMockedUser } from 'src/hooks/use-mocked-user';
import { useRouter } from 'src/routes/hooks';
import { useDeleteAccountMutation } from 'src/store/Reducer/settings';
import { logout } from 'src/store/slices/userSlice';

const DeleteAccount = () => {

    const theme = useTheme();
    const router = useRouter(); 

    const open = useBoolean();

    const { user } = useMockedUser();
    const redux = useSelector((state) => state.user);   

    const [deleteAccount, setDeleteAccount] = useState("");
    const dispatch = useDispatch();    

    const [deleteAccountMutation, { isLoading: deleteLoading }] = useDeleteAccountMutation();

    const handleDeleteAccount = async () => {
        try {
            const response =  await deleteAccountMutation({
                // role: user?.user_type === "contractor" && "contractor",
                role:  "contractor",
                data: {
                    device_id:redux?.device_id || 'abc',
                }
            });
            if (!response?.error) {
                enqueueSnackbar(response?.data?.message || "Account delete successfully", { variant: "success" }); // ✅ Show success message
                open.onFalse();          // ✅ Close dialog
                setDeleteAccount("");    // ✅ Reset input field
                dispatch(logout()); // ✅ Log out user
                router.push("/login"); // ✅ Redirect to login page
                
            }
        } catch (error) {
            console.error("Failed to delete account:", error);
        }
    };

    return (
        <div>
            <Card sx={{ p: 3, borderRadius: 2 }}>
                <Typography variant="h6" sx={{ mb: 3, fontWeight: "bold", color: "error.main", display: "flex", alignItems: "center" }}>
                    <Iconify icon="material-symbols:warning-rounded" sx={{ mr: 2 }} />
                    Delete Account
                </Typography>

                <Stack spacing={2}>
                    <Typography variant="body1" paragraph>
                        <strong>Warning:</strong> This action will permanently delete your account and all associated data. This cannot be undone.
                    </Typography>

                    <LoadingButton variant="contained" color="error" onClick={open.onTrue} sx={{ alignSelf: "flex-start", fontWeight: "bold" }}>
                        Delete
                    </LoadingButton>
                </Stack>

                <Dialog maxWidth="sm" open={open.value} onClose={open.onFalse}>
                    <DialogTitle>Confirm Account Deletion</DialogTitle>

                    <DialogContent>
                        <Typography variant="body1" paragraph color="text.secondary">
                            <Iconify icon="material-symbols:warning-rounded" color="error.main" /> <strong>Are you sure you want to delete your account? This action cannot be undone.</strong>
                        </Typography>

                        <TextField
                            name="deleteAccount"
                            type="text"
                            value={deleteAccount}
                            onChange={(e) => setDeleteAccount(e.target.value)}
                            label='To confirm, type "Delete Account"'
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            sx={{ my: 3 }}
                            aria-label="Delete Account Confirmation"
                            placeholder='Type "Delete Account" to confirm'
                        />
                    </DialogContent>

                    <DialogActions>
                        <Button onClick={open.onFalse} color="inherit">
                            Cancel
                        </Button>
                        <LoadingButton
                            loading={deleteLoading}
                            onClick={handleDeleteAccount}
                            color="error"
                            variant="contained"
                            disabled={deleteAccount !== "Delete Account"}
                        >
                            Delete Account
                        </LoadingButton>
                    </DialogActions>
                </Dialog>
            </Card>
        </div>
    );
};

export default DeleteAccount;